<section [id]="id">
  <div class="card-container">

    @if (headingText) {
      <h1>{{headingText}}</h1>
    }
    <p [innerText]="visibleText"></p>
    @if (show) {
      <p
        @fadeInOut
      [innerText]="hiddenText"></p>
    }

  </div>
  <button (click)="toggle()"
    type="button"
    id="showLessBtn">
    {{show ? hideText : showText }}
  </button>
</section>